<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import {
  sjclzx_pz_query,
  sjclzx_ywlxquery,
  sjclzx_ywlxquery_set,
  queryCompanyList,
  sjclzx_pz_updateBusinessType,
  sjclzx_pz_setBusinessMatchStatus,
  sjclzx_pz_disassociate
} from "../../../../../api/sjclzx.js";
import config from "../../../../../../configHttp.js";
import {comMapping} from "@/components/util/Function/comMapping";

export default {
  props: {
    resSearchdata: {
      default: {}
    }
  },
  data: function () {
    return {
      businessTypes: [],
      formateBusinessTypes: [],
      disasSociates: [{label: '置为暂不处理', value: '2'}, {label: '置为未匹配', value: '0'}],
      shaidiag: false,
      headData: getdata().headData,
      outlist: [],
      searchdiag: false,
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0
    };
  },
  created() {
    if (this.resSearchdata) {
      this.searchdata = this.resSearchdata;
    }
    this.getData();
    this.loadData();
  },
  mounted() {
  },
  methods: {
    geOoverLength(e) {
      this.overlength = e;
    },
    loadData() {
      queryCompanyList().then(res => {
        if (res.data.code === 1) {
          let companyCodeVal = [];
          for (let i = 0; i < res.data.data.length; i++) {
            companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
          }
          this.searchlist[5].selectval = companyCodeVal;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        } else {
          this.$message.error(res.data.msg)
        }
      });

      sjclzx_ywlxquery_set({resRange: "0"}).then((res) => {
        if (res.data.code === "1") {
          this.businessTypes = res.data.data;
          this.searchlist[1].selectval = res.data.data;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        }
      });

      sjclzx_ywlxquery({resRange: "0"}).then((res) => {
        if (res.data.code === "1") {
          this.formateBusinessTypes = res.data.data;
        }
      });
    },
    getData() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum
      params.size = this.pagination.pageSize
      sjclzx_pz_query(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.pagination.paginationkey++;
        for (let i = 0; i < res.data.data.records.length; i++) {
          if (res.data.data.records[i].kaiprq) {
            let kaiprqs = res.data.data.records[i].kaiprq.split(",");
            for (let j = 0; j < kaiprqs.length; j++) {
              kaiprqs[j] = this.$yyyyMMdd(kaiprqs[j]);
            }
            res.data.data.records[i].kaiprq = kaiprqs.join(",");
          }
        }
        this.tableData = res.data.data.records;
      });
    },
    updateBusinessType(value) {
      // 设置业务类型
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      let msg = "";
      for (let i = 0; i < chooseItem.length; i++) {
        if (chooseItem[i].businessMatchStatus === "1") {
          if (chooseItem[i].businessType === "xxskcy_001" || chooseItem[i].businessType === "xxskcy_002") {
            // 4)如果当前处理状态为匹配完成且业务类型 in (票账相符,票账有差),需要提示“票账相符/票账有差需要执行取消关联操作!”
            this.$message.error("票账相符/票账有差需要执行取消关联操作!");
            return false;
          } else {
            // 3)如果当前处理状态为匹配完成且业务类型not in(票账相符,票账有差),需要提示“当前处理状态为匹配完成,业务类型为XXX,确认要切换吗?”
            msg += "凭证[" + chooseItem[i].voucherNo + "]当前处理状态为匹配完成,业务类型为" + this.businessTypeFormat(chooseItem[i].businessType) + ",";
          }
        }
      }
      if (msg.length > 0) {
        this.$showConfirm({
          message: msg + "确认要切换吗?",
        }).then((res) => {
          if (res === "confirm") {
            this.confirmUpdateBusinessType(chooseItem, value);
          }
        });
      } else {
        this.confirmUpdateBusinessType(chooseItem, value);
      }
    },
    confirmUpdateBusinessType(chooseItem, value) {
      let ids = chooseItem.map((item) => item.id);
      sjclzx_pz_updateBusinessType({idList: ids, businessType: value}).then((res) => {
        if (res.data.code === 1) {
          this.getData();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    setBusinessMatchStatus(status) {
      // 设置处理状态
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      // 仅允许选择业务类型为未处理票账的数据置为暂不处理/未匹配,否则提示“请选择业务类型为未处理票账的数据!”
      for (let i = 0; i < chooseItem.length; i++) {
        if (chooseItem[i].businessType && chooseItem[i].businessType !== "xxskcy_000") {
          this.$message.error("请选择业务类型为空或未处理票账的数据!");
          return false;
        }
      }
      let ids = chooseItem.map((item) => item.id);
      sjclzx_pz_setBusinessMatchStatus({idList: ids, status: status}).then((res) => {
        if (res.data.code === 1) {
          this.getData();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    matchNodes() {
      // 手工处理
      let chooseItem = this.$refs.tablebox.getSelectionval();
      // 3)如果没有选择任何一条数据,需要提示“请选择至少一条数据!”
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择至少一条数据!");
        return false;
      }
      let voucherNos = [];
      // 凭证记账日期是否在同月标记
      let postingDateFlag = true;
      let date = new Date(chooseItem[0].postingDate)
      let new_year = date.getFullYear() // 取当前的年份
      let month = date.getMonth()
      for (let i = 0; i < chooseItem.length; i++) {
        // 1)支持批量选择,仅能选择同一公司编号下的数据,否则提示“请选择同一公司编号的数据!”
        if (chooseItem[0].companyCode !== chooseItem[i].companyCode) {
          this.$message.error("请选择同一公司编号的数据!");
          return false;
        }
        // 2)仅能选择处理状态为未匹配的数据,否则提示“请选择处理状态为未匹配的数据!”
        if (chooseItem[i].businessMatchStatus !== "0") {
          this.$message.error("请选择处理状态为未匹配的数据!");
          return false;
        }
        // 4)带出的凭证和发票必须均为一个实体,且未匹配,业务类型为空的数据
        if (chooseItem[i].businessType && chooseItem[i].businessType !== "xxskcy_000") {
          this.$message.error("请选择业务类型为空或未处理票账的数据!");
          return false;
        }
        voucherNos.push(chooseItem[i].voucherNo);
        let nowDate = new Date(chooseItem[i].postingDate)
        if (new_year !== nowDate.getFullYear() || month !== nowDate.getMonth()) {
          postingDateFlag = false;
        }
      }
      let kaiprqs = [];
      if (postingDateFlag) {
        // 开票日期条件默认为该凭证记账日期所属的月份1-31日
        let new_month = month + 1 // 取当前的月份
        let firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天
        let lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
        let mon;
        if (firstDay.getMonth() < 10) {
          mon = "0" + firstDay.getMonth()
        } else {
          mon = firstDay.getMonth()
        }
        kaiprqs[0] = firstDay.getFullYear() + mon + "01";
        kaiprqs[1] = firstDay.getFullYear() + mon + lastDay;
      }
      this.$emit("updateSgclFlag", true);
      this.$emit("setParams", {voucherNos: voucherNos, companyCode: chooseItem[0].companyCode, kaiprqs: kaiprqs});
      this.$emit("setPzSearchdata", this.searchdata);
    },
    disassociate(value) {
      // 取消关联
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      for (let i = 0; i < chooseItem.length; i++) {
        if (chooseItem[i].businessType !== "xxskcy_001" && chooseItem[i].businessType !== "xxskcy_002") {
          this.$message.error("请选择票账相符/票账有差的数据!");
          return false;
        }
      }
      let ids = chooseItem.map((item) => item.id);
      let disasSociate = this.disasSociates.find(item => item.value === value);
      this.$showConfirm({
        message: "请确认是否要取消关联，确认后关联数据均被取消且匹配状态置为" + (disasSociate ? disasSociate.label : "") + "，定时任务不执行该数据！",
      }).then((res) => {
        if (res === "confirm") {
          sjclzx_pz_disassociate({idList: ids, businessMatchStatus: value}).then((res) => {
            if (res.data.code === 1) {
              this.getData();
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg)
            }
          });
        }
      });
    },
    exportVoucher() {
      // 导出
      // 得到勾选的列表值：
      let chooseItem = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (chooseItem.length > 0) {
        data.ids = chooseItem.map((item) => item.id);
      } else {
        data.searchInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "/dataDisposeCenter/voucher/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          failUrl: this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    // 处理状态format
    businessMatchStatusFormat(val) {
      let item = comMapping.$businessMatchStatus.find(status => status.value === val);
      return item ? item.label : val;
    },
    // 业务类型format
    businessTypeFormat(val) {
      let item = this.formateBusinessTypes.find(status => status.value === val);
      return item ? item.label : val;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange() {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getData();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.getData();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.getData();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
